export const getDelegators = state => state.users.delegators;